import { render } from "./MyIndexPage.vue?vue&type=template&id=59ce3fa4&scoped=true"
const script = {}

import "./MyIndexPage.vue?vue&type=style&index=0&id=59ce3fa4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ce3fa4"]])

export default __exports__